import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box,
} from "@mui/material";
import { useDropzone } from "react-dropzone";

const AddDailyReportFileModal = ({ visible, onClose, onSubmit }) => {
    const [file, setFile] = useState(null);
    const [sheetName, setSheetName] = useState("");

    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const selectedFile = acceptedFiles[0];
            if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                setFile(selectedFile);
            } else {
                alert("Lỗi file, vui lòng thử lại.");
            }
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: ".xlsx",
        multiple: false,
    });

    const handleSubmit = () => {
        if (!file) {
            alert("Chưa chọn file.");
            return;
        }
        if (!sheetName.trim()) {
            alert("Chưa nhập tên sheet.");
            return;
        }
        onSubmit({ file, sheetName });
        setFile(null);
        setSheetName("");
        onClose();
    };

    return (
        <Dialog open={visible} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Thêm báo cáo hàng ngày</DialogTitle>
            <DialogContent>
                <Box
                    {...getRootProps()}
                    sx={{
                        border: "2px dashed #d9d9d9",
                        borderRadius: "4px",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                        marginBottom: "20px",
                    }}
                >
                    <input {...getInputProps()} />
                    <Typography variant="body1" color="primary">
                        Kéo thả file hoặc chọn file .xlxs
                    </Typography>
                </Box>
                {file && (
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        align="center"
                        sx={{ marginBottom: "10px" }}
                    >
                        File đang chọn: {file.name}
                    </Typography>
                )}
                <TextField
                    fullWidth
                    label="Nhập tên sheet"
                    value={sheetName}
                    onChange={(e) => setSheetName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Hủy
                </Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Tải lên
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddDailyReportFileModal;